// Same station/airport matching the ContactModal uses, for the bot's home-page route step.
import stationsData from '../../data/stations.json';
import airportsData from '../../data/airports.json';

let INDEX = null;

const getIndex = () => {
    if (INDEX) return INDEX;
    const stations = (stationsData || [])
        .filter(s => s && s.stationCode && s.stationName)
        .map(s => ({
            type: 'station',
            code: String(s.stationCode).toUpperCase(),
            name: String(s.stationName),
            city: '',
            lat: Number(s.lat || s.lat_long?.[0] || 0),
            lng: Number(s.lng || s.lat_long?.[1] || 0),
        }));
    const airports = (airportsData || [])
        .filter(a => a && a.airportCode && a.airportName)
        .map(a => ({
            type: 'airport',
            code: String(a.airportCode).toUpperCase(),
            name: String(a.airportName),
            city: String(a.city || a.cityName || ''),
            lat: Number(a.lat || a.lat_long?.[0] || 0),
            lng: Number(a.lng || a.lat_long?.[1] || 0),
        }));
    INDEX = [...stations, ...airports].map(item => ({
        ...item,
        _name: item.name.toUpperCase(),
        _city: item.city.toUpperCase(),
        label: `${item.name} (${item.code})`,
    }));
    return INDEX;
};

export const searchLocations = (query, limit = 6) => {
    const q = String(query || '').trim().toUpperCase();
    if (q.length < 2) return [];
    const scored = [];
    for (const item of getIndex()) {
        let score = -1;
        if (item.code === q) score = 0;
        else if (item._name.startsWith(q) || item._city.startsWith(q)) score = 1;
        else if (item.code.startsWith(q)) score = 2;
        else if (item._name.includes(` ${q}`)) score = 3;
        else if (item._name.includes(q) || item._city.includes(q)) score = 4;
        if (score >= 0) scored.push([score, item]);
    }
    scored.sort((a, b) => a[0] - b[0] || a[1]._name.length - b[1]._name.length);
    return scored.slice(0, limit).map(([, item]) => item);
};
